import { useRef, useState, useEffect, useCallback } from 'react';
import Helmet from 'react-helmet';
import SunEditor, { buttonList } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import {
    EditorComposer,
    Editor,
    ToolbarPlugin,
    AlignDropdown,
    BackgroundColorPicker,
    BoldButton,
    CodeFormatButton,
    FloatingLinkEditor,
    FontFamilyDropdown,
    FontSizeDropdown,
    InsertDropdown,
    InsertLinkButton,
    ItalicButton,
    TextColorPicker,
    TextFormatDropdown,
    UnderlineButton,
    Divider,
} from 'verbum';

const getRawText = d => {
    var text = "";
    var e = JSON.parse(d);

    if (e.root) e = e.root;

    if (e.children) {
        for (var i = 0; i < e.children.length; i++) {
            var ee = e.children[i];
            var text_add = "";
            if (ee.type == 'text') text_add = ee.text;
            if (ee.children) text_add = getRawText(JSON.stringify(ee));

            if (text_add != "") {
                text += text_add.trimEnd() + " ";
            }
        }
    }

    return text.replace(/\s\s+/g, ' ');
}


const RichTextEditor = props => {

    //hide popup on verbum/lexicaljs


    // The sunEditor parameter will be set to the core suneditor instance when this function is called
    const editor = useRef();
    const getSunEditorInstance = (sunEditor) => {
        editor.current = sunEditor;
    };
    const initialValue = props.initialValue != "" ? props.initialValue : null

    //defaulteditor -> lexical
    const DefEditor = <div>
        <EditorComposer
            initialEditorState={initialValue}>
            <Editor
                hashtagsEnabled={true}
                onChange={e => {
                    if (props.onChange) props.onChange(e, getRawText(e));
                    if (props.debug) console.log(`${e}\n\n${getRawText(e)}`);
                }}
                isEditable={props.readOnly ? false : true}>
                {

                    props.readOnly ? <></> : <ToolbarPlugin defaultFontSize="20px">
                        <FontFamilyDropdown />
                        <FontSizeDropdown />
                        <Divider />
                        <BoldButton />
                        <ItalicButton />
                        <UnderlineButton />
                        <CodeFormatButton />
                        <InsertLinkButton />
                        <TextColorPicker />
                        <BackgroundColorPicker />
                        <TextFormatDropdown />
                        <Divider />
                        <InsertDropdown enablePoll={true} />
                        <Divider />
                        <AlignDropdown />
                    </ToolbarPlugin>
                }
            </Editor>
        </EditorComposer>
    </div>;    

    return (
        <div>
            {
                props.readOnly ?
                    <Helmet>
                        <style type="text/css">{`
                            .character-style-popup{
                                display: none;
                            }
                        `}
                        </style>
                    </Helmet> : <></>
            }
            {
                props.editor == "suneditor" ? 
                    <SunEditor
                        setContents={props.initialValue ?? ""}
                        onChange={props.onChange}
                        name={props.name}
                        readOnly={props.readOnly}
                        setOptions={{
                            height: 200,
                            buttonList: props.readOnly ? [] : buttonList.complex // Or Array of button list, eg. [['font', 'align'], ['image']]
                            // Other option
                        }}
                        getSunEditorInstance={getSunEditorInstance} /> : <>
                        {
                            DefEditor
                        }
                    </>
            }
            
        </div>
    );
};
export default RichTextEditor;